<template>
  <div
    v-if="showTooltip || !isTooltip"
    class="hot-spot__container"
    :class="{ rounded: isTooltip }"
  >
    <div v-if="isTooltip" class="close-btn position-absolute right-0 top-0">
      <v-btn icon large @click="showTooltip = false">
        <v-icon>mdi-close</v-icon>
      </v-btn>
    </div>
    <div v-if="!isTooltip" class="hot-spot__header">
      {{ title }}
      <div v-if="!hideClose" class="close-btn">
        <v-btn icon large @click="$emit('close')">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </div>
    </div>
    <div
      class="hot-spot__body"
      :class="{
        'pb-6': isTooltip,
        'rounded-b': !(
          !isTooltip &&
          (step > 0 ||
            contents.length > 1 ||
            (step < contents.length && !hideBtn))
        ),
      }"
    >
      <v-carousel
        ref="carouselBox"
        v-model="step"
        class="h-auto"
        hide-delimiters
        :show-arrows="false"
      >
        <v-carousel-item v-for="(text, i) in contents" :key="i">
          <div class="hot-spot__text" v-html="text"></div>
        </v-carousel-item>
      </v-carousel>
    </div>
    <div
      v-if="
        !isTooltip &&
        (step > 0 ||
          contents.length > 1 ||
          (step < contents.length && !hideBtn))
      "
      class="hot-spot__footer"
    >
      <div v-if="!hideClose" class="prev-btn">
        <v-btn v-if="step > 0" @click="prev"> Prev </v-btn>
      </div>
      <div v-if="contents.length > 1">
        {{ step + 1 }}/{{ contents.length || 1 }}
      </div>
      <div v-if="step < contents.length && !hideBtn" class="submit-btn">
        <v-btn @click="next">
          {{ step === contents.length - 1 ? finishText : 'Next' }}
        </v-btn>
      </div>
    </div>
    <div
      v-if="bottom && !top && !left && !right"
      class="arrow-down"
      :class="{ 'right-position': leftPos2 }"
      :style="{
        left:
          leftClass !== 'interested-hotspot' && leftPos1
            ? `${leftPos1}px`
            : null,
        right: leftPos2 ? `${leftPos2}px` : null,
      }"
    ></div>
    <div
      v-if="top"
      class="arrow-up"
      :style="{
        left:
          leftClass === 'interested-hotspot' && leftPos1
            ? `${leftPos1}px`
            : null,
      }"
    ></div>
    <div v-if="left" class="arrow-left"></div>
    <div v-if="right" class="arrow-right"></div>
  </div>
</template>
<script>
export default {
  name: 'HotSpot',
  props: {
    title: String,
    contents: {
      type: Array,
      default: () => [],
    },

    finishText: {
      type: String,
      default: 'Got it',
    },

    value: {
      type: [String, Number],
      default: null,
    },

    top: {
      type: Boolean,
      default: false,
    },

    bottom: {
      type: Boolean,
      default: true,
    },

    left: {
      type: Boolean,
      default: false,
    },

    right: {
      type: Boolean,
      default: false,
    },

    hideClose: Boolean,
    hideBtn: Boolean,
    isTooltip: Boolean,
    leftClass: String,
    rightClass: String,
    showFakeCard: Boolean,
  },

  data() {
    return {
      step: 0,
      showTooltip: false,
      leftPos1: 0,
      leftPos2: 0,
    };
  },

  mounted() {
    if (this.value) {
      this.step = this.value;
    }
    if (this.isTooltip) {
      this.showTooltip = true;
      setTimeout(() => {
        this.$emit('close');
      }, 5000);
    }
    this.getLeft();
    this.getRight();
  },

  methods: {
    next() {
      if (this.step === this.contents.length - 1) {
        this.$emit('close');
      } else {
        this.step += 1;
        this.$emit('next');
      }
    },

    prev() {
      this.step -= 1;
      this.$emit('prev');
    },

    getLeft() {
      if (!this.leftClass) return;
      let a = 0;
      if (this.leftClass === 'interested-hotspot') {
        a = document.getElementsByClassName('interested-hotspot').length
          ? document
              .getElementsByClassName('interested-hotspot')[0]
              .getBoundingClientRect().left - (this.showFakeCard ? 240 : 270)
          : 0;
      } else {
        a = document.getElementsByClassName('reject-hotspot').length
          ? document
              .getElementsByClassName('reject-hotspot')[0]
              .getBoundingClientRect().left - (this.showFakeCard ? 270 : 305)
          : 0;
      }
      if (window.innerWidth < 1171) {
        a = Math.abs(a) - 30;
      }
      this.leftPos1 = a < 192 ? Math.abs(a) : 0;
    },

    getRight() {
      if (!this.rightClass) return;
      const a = document.getElementsByClassName('approve-hotspot').length
        ? document
            .getElementsByClassName('approve-hotspot')[0]
            .getBoundingClientRect().right
        : 0;
      const w = window.innerWidth;
      let r = w - a - 430;
      if (this.showFakeCard) {
        r += 30;
      }
      this.leftPos2 = r < 192 ? Math.abs(r) : 0;
    },
  },
};
</script>
<style lang="scss" scoped>
.hot-spot {
  &__container {
    box-shadow: -2px 2px 27px 0 rgba(0, 0, 0, 0.5);
    border-radius: 8px;
    position: absolute;
    bottom: 100%;
    left: 50%;
    transform: translate(-50%, -30px);
    width: 350px;
    z-index: 99;
    &.rounded {
      border-radius: 12px !important;
      overflow: hidden;
    }
  }
  &__header {
    background: #4f46e5;
    border-radius: 8px 8px 0 0;
    text-align: center;
    padding: 10px;
    color: #fff;
    font-size: 14px;
    font-weight: 600;
    .close-btn {
      position: absolute;
      top: 0px;
      right: 10px;
      &::v-deep {
        .v-btn--icon {
          color: #fff;
        }
      }
    }
  }
  &__body {
    background: #fff;
    padding: 16px 24px 32px;
    font-size: 13px;
    color: #111827;
    &.rounded-b {
      border-radius: 0 0 8px 8px !important;
    }
  }
  &__footer {
    background: #fff;
    border-radius: 0 0 8px 8px;
    color: #111827;
    font-size: 12px;
    font-weight: 500;
    text-align: center;
    padding: 12px 12px 16px;
    position: relative;
    min-height: 50px;
    .submit-btn {
      position: absolute;
      top: 0px;
      right: 30px;
      &::v-deep {
        .v-btn--has-bg {
          background: #4f46e5;
          color: #fff;
          height: 32px;
          font-size: 14px;
        }
      }
    }
    .prev-btn {
      position: absolute;
      top: 0px;
      left: 30px;
      &::v-deep {
        .v-btn--has-bg {
          background: transparent;
          color: #111827;
          height: 32px;
          font-size: 14px;
        }
      }
    }
  }
}
.arrow-down {
  position: absolute;
  top: 100%;
  left: 50%;
  transform: translate(-50%, -2px);
  width: 0;
  height: 0;
  border-left: 10px solid transparent;
  border-right: 10px solid transparent;

  border-top: 20px solid #fff;
  &.right-position {
    left: auto;
    right: 0;
  }
}
.arrow-up {
  position: absolute;
  bottom: 100%;
  left: 50%;
  transform: translate(-50%, 2px);
  width: 0;
  height: 0;
  border-left: 10px solid transparent;
  border-right: 10px solid transparent;

  border-bottom: 20px solid #4f46e5;
}
.arrow-left {
  position: absolute;
  right: 100%;
  top: 50%;
  transform: translate(2px, -50%);
  width: 0;
  height: 0;
  border-top: 10px solid transparent;
  border-bottom: 10px solid transparent;

  border-right: 20px solid #fff;
}
.arrow-right {
  position: absolute;
  left: 100%;
  top: 50%;
  transform: translate(-2px, -50%);
  width: 0;
  height: 0;
  border-top: 10px solid transparent;
  border-bottom: 10px solid transparent;

  border-left: 20px solid #fff;
}
.h-auto {
  height: auto !important;
  &::v-deep {
    .v-carousel__item {
      height: auto !important;
    }
  }
}
.right-0 {
  right: 0px;
}
.top-0 {
  top: 0px;
}
</style>
